import React from 'react'
import { WrappedStoryDispatchAction } from './wrappedStoryStateReducer'
import noop from 'lib/function/noop'

const WrappedStoryDispatchContext = React.createContext<React.Dispatch<WrappedStoryDispatchAction>>(noop)

export default WrappedStoryDispatchContext
